<script>
  import { getAppConfig } from '../../../../common/config/app-config';
  import { APP_CONSTANTS } from '../../../../common/config/app-constants';
  import { getStr, globalCurrencyTag } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import Text from '../../../common/components/Text.svelte';
  import VDivider from '../VDivider.svelte';

  export let currency;
  export let targetBundlePrice;
  export let initialBundlePrice;
  export let size = '';
  export let percentDiscount;
  export let installmentPrice;
  export let savingAmount;
  export let tashleelPrice;
  export let discountPrice;
  export let tasheelPriceValuesList;
  export let bundleTasheelPriceValue;

  $: tasheelPercentage = bundleTasheelPriceValue?.tasheelPercentage;
  $: tasheelMonths = bundleTasheelPriceValue?.tasheelInstallmentMonths;

  const off = getStr('extra.product.cashback.off');
  const save = getStr('extra.product.cashback.save');

  const {
    unbxdSearchConfig: { tasheelInfo },
    bnplBaseetaPaymentModeEnabled,
  } = getAppConfig();
</script>

<section class="bundle-bottom">
  <section class="product_price {size}">
    <div class="product_price__left">
      <div class="price-row {size}">
        {#if size === 'small'}
          {#if discountPrice}
            <span class="amount font-weight-bold">
              <!-- {@html globalCurrencyTag}
              <span class="amount font-weight-bold">{discountPrice?.formattedValue}</span> -->
              <Text key="jood.price.with.currency" args={[globalCurrencyTag, discountPrice?.formattedValue]} />
            </span>
          {:else}
            <span class="amount font-weight-bold">
              <!-- {@html globalCurrencyTag}
              <span class="amount font-weight-bold">{targetBundlePrice}</span> -->
              <Text key="jood.price.with.currency" args={[globalCurrencyTag, targetBundlePrice]} />
            </span>
          {/if}
        {:else}
          <span class="amount font-weight-bold">
            <!-- {@html globalCurrencyTag}
            <span class="amount font-weight-bold">{targetBundlePrice}</span> -->
            <Text key="jood.price.with.currency" args={[globalCurrencyTag, targetBundlePrice]} />
          </span>
        {/if}
      </div>
      {#if discountPrice}
        <div class="discount-row">
          {#if size === 'small'}
            <div class="old-price">{targetBundlePrice}</div>
            <div class="percent-discount" class:hidden={!percentDiscount}>
              {percentDiscount}% {off}
            </div>
          {:else}
            <div class="old-price">{initialBundlePrice}</div>
            <div class="price-savings font-weight-bold">
              {save}
              <Text key="jood.price.with.currency" args={[globalCurrencyTag, savingAmount]} />

              <!-- {@html globalCurrencyTag}
              {savingAmount} -->
            </div>
          {/if}
        </div>
      {:else}
        <div class="discount-row">
          {#if size !== 'small'}
            <div class="old-price">{initialBundlePrice}</div>
            <div class="price-savings font-weight-bold">
              {save}
              <!-- {@html globalCurrencyTag}
              {savingAmount} -->
              <Text key="jood.price.with.currency" args={[globalCurrencyTag, savingAmount]} />
            </div>
          {/if}
        </div>
      {/if}
    </div>

    {#if tasheelInfo.tasheelEnabled && installmentPrice && installmentPrice > 0 && bnplBaseetaPaymentModeEnabled}
      <VDivider />
      <div class="product_price__right">
        <div class="price-row {size}">
          {#if size === 'small'}
            <span>
              <!-- {@html globalCurrencyTag}
              <span class="amount font-weight-bold">{tashleelPrice && tashleelPrice}</span> -->
              <Text key="jood.price.with.currency" args={[globalCurrencyTag, tashleelPrice && tashleelPrice]} />
            </span>
          {:else}
            <span>
              <!-- {@html globalCurrencyTag}
              <span class="amount font-weight-bold">{installmentPrice}/<Text key="extra.pdp.monthLable" /></span> -->
              <Text key="jood.price.with.currency" args={[globalCurrencyTag, installmentPrice]} />/<Text
                key="extra.pdp.monthLable"
              />
            </span>
            <div class="tasheel-icon hide-on-desktop">
              <Icon
                type="url"
                glyph={`${tasheelInfo.tasheelIconUrl ? tasheelInfo.tasheelIconUrl : APP_CONSTANTS.CDN_EXTRASTORE + '/2x/secondary/tasheel-logos.svg'}`}
                alt="Tasheel logo"
                mobileSize="16"
                desktopSize="20"
              />
            </div>
            <div class="tasheel-icon hide-on-mobile">
              <Icon
                type="url"
                glyph={`${tasheelInfo.tasheelImageUrl ? tasheelInfo.tasheelImageUrl : APP_CONSTANTS.CDN_EXTRASTORE + '/2x/secondary/tasheel-logos.svg'}`}
                alt="Tasheel logo"
                mobileSize="26"
                desktopSize="20"
              />
            </div>
          {/if}
        </div>
        <div class="finance-row">
          {#if tasheelPercentage && tasheelMonths}
            <div class="finance-text font-weight-regular">
              <Text key="extra.tasheel.priceValue.desc" args={[tasheelPercentage, tasheelMonths]} />
            </div>
          {/if}
        </div>
      </div>
    {/if}
  </section>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .product_price {
    display: flex;
    color: $neutral-dark-01;
    gap: 8px;
    background-color: $neutral-light-04;
    &.small {
      background-color: $primary-white;
    }
  }
  .price-row,
  .discount-row {
    display: flex;
    align-items: baseline;
    gap: 4px;
  }
  .price-row {
    .amount-info {
      .amount {
        font-weight: 700;
      }
    }
  }
  .discount-row {
    align-items: center;
  }
  .vat-info {
    color: $neutral-dark-04;
    font-weight: 400;
    font-size: 10px;
    line-height: 11px;
  }
  .old-price {
    text-decoration: line-through;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
  .price-savings {
    color: $extraTagBg;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
  }
  .percent-discount {
    color: $extraTagTextColor;
    background: $extraTagBg;
    padding: 3px 4px;
    border-radius: 3px;
    font-weight: 700;
    font-size: 10px;
    line-height: 10px;
    gap: 2px;
  }
  .tasheel-info {
    width: 13px;
    object-fit: contain;
    object-position: center bottom;
  }
  .finance-text {
    font-weight: 400;
    font-size: 11px;
    line-height: 12px;
  }

  @include desktop-min-width {
    .product_price {
      padding: 0;
    }
    .price-row {
      line-height: 20px;
      font-size: 18px;
      .amount-info {
        .amount {
          font-weight: 700;
        }
      }

      &.small {
        line-height: 18px;
        font-size: 16px;
      }
    }
    .vat-info {
      font-size: 12px;
      line-height: 14px;
    }
    .tasheel-info {
      width: 48px;
    }
    .old-price {
      font-size: 12px;
      line-height: 14px;
      color: $neutral-dark-03;
    }

    .price-savings {
      font-size: 16px;
      line-height: 18px;
    }
    .finance-text {
      font-size: 12px;
      line-height: 14px;
      color: $neutral-dark-03;
      text-align: left;
    }
  }

  .hidden {
    display: none;
  }
</style>
